"use client";

import { useEffect, useState } from "react";
import { Heart } from "lucide-react";
import cn from "classnames";

interface ToggleFavoriteProps {
    id?: string; // id может быть необязательным
}

export function ToggleFavorite({ id }: ToggleFavoriteProps) {
    const [isFavorite, setIsFavorite] = useState(false);

    useEffect(() => {
        if (!id) return;
        const favorites = JSON.parse(localStorage.getItem("favorites") || "[]");
        setIsFavorite(favorites.includes(id));
    }, [id]);

    const toggleFavorite = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation(); // Если используется в карточке — предотвращает переход

        if (!id) return;

        const favorites = JSON.parse(localStorage.getItem("favorites") || "[]");

        if (favorites.includes(id)) {
            const updatedFavorites = favorites.filter((favId: string) => favId !== id);
            localStorage.setItem("favorites", JSON.stringify(updatedFavorites));
            setIsFavorite(false);
        } else {
            favorites.push(id);
            localStorage.setItem("favorites", JSON.stringify(favorites));
            setIsFavorite(true);
        }
    };

    return (
        <Heart
            onClick={toggleFavorite}
            className={cn(
                "cursor-pointer transition-colors",
                isFavorite ? "fill-green-600 text-green-600" : "fill-none text-green-600"
            )}
            size={24}
        />
    );
}
